export const TROUBLE_SPOTS_LIST = 'trouble_spots_list';
export const TROUBLE_SPOTS_LIST_SUCCESS = 'trouble_spots_list_success';
export const RECOMMEND_SKILL ='recommend_skill';
